import { render, staticRenderFns } from "./FileIconThumbnail.vue?vue&type=template&id=3b6b3d5e"
import script from "./FileIconThumbnail.vue?vue&type=script&lang=js"
export * from "./FileIconThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports